import { HorizBox, HoverView, Pad, PadBox } from "component/basics"
import { UtilityText } from "component/text"
import { StyleSheet, View } from 'react-native';
import { FacePile } from 'component/people'
import { PercentageBar, PercentageBarContainer } from './videovotingPercentageBars';
import { colorAmbigousBlack, colorBorderPrimary, colorDataVizStrong, colorGrey5, colorSurfacePrimary, colorSurfaceSecondary, colorTextOnBlackBackground, colorTextOnDarkBackground, colorTextOnLightColorTag, colorTextPrimary } from "component/color"
import { Checkmark } from "@carbon/icons-react";

export type OptionRadioButtonProps = {
    selected: boolean;
    onPress: () => void;
    testID?: string;
};

export type VideoVotingOptionProps = {
    optionText: string;
    selected: boolean;
    voteCount?: number;
    allVoteCount?: number;
    voterKeys?: string[];
    onSelect: () => void;
    votingEnabled?: boolean;
    showResults?: boolean;
};


// TODO This is copied from the poll picker component
// The radio button needs to be an own component for everyone
function OptionRadioButton({ selected, onPress, testID }: OptionRadioButtonProps) {
    const s = OptionRadioButtonStyle
    return <HoverView testID={testID}
        onPress={onPress}>
        <View style={[s.rightIcon, selected ? s.iconSelected : '']}>
            <Checkmark />
        </View>
    </HoverView>
}

const OptionRadioButtonStyle = StyleSheet.create({
    body: {
        flex: 1
    },
    rightIcon: {
        borderColor: colorBorderPrimary,
        borderRadius: 100,
        borderWidth: 1,
        padding: 4,
        color: colorSurfacePrimary
    },
    iconSelected: {
        backgroundColor: colorTextPrimary,
        borderColor: colorTextPrimary,
        color: colorTextOnBlackBackground
    }
})

/**
 * Displays one answer option of a question with a specific range of votes
 */
// FIXME: This function is too large and should be broken up
/* eslint-disable-next-line max-lines-per-function */
export function VideoVotingOption({ optionText, selected, voteCount = 0, allVoteCount = 0, voterKeys = [], onSelect, votingEnabled, showResults }: VideoVotingOptionProps) {

    const percentage = allVoteCount > 0 ? voteCount*100/allVoteCount : 0

    return (
        <PadBox bottom={20}>
            <HorizBox center>
                <View style={{ flex: 1 }}>
                    <HorizBox spread center>
                        <View style={{ flex: 1 }}>
                            <UtilityText text={optionText} />
                        </View>
                        <View style={{ opacity: showResults ? 1 : 0 }}>
                            <HorizBox center>
                                <View style={{ position: "relative", left: 10 }}>
                                    <FacePile type="tiny" userIdList={voterKeys} />
                                </View>
                                <View style={videoVotingOptionStyle.tag}>
                                    <UtilityText type="small" text={voteCount.toString()} color={colorTextOnLightColorTag}/>
                                </View>
                            </HorizBox>
                        </View>
                    </HorizBox>
                    <Pad size={4} />
                    <View
                        style={[
                            { flexGrow: 1, position: "relative", opacity: showResults ? 1 : 0 },
                            videoVotingOptionStyle.percentageBarBase,
                        ]}
                    >
                        <PercentageBarContainer backgroundColor={"#d6d6d6"}>
                            <PercentageBar
                                percentages={[percentage]}
                                colors={[selected ? colorDataVizStrong : colorGrey5]}
                            />
                        </PercentageBarContainer>
                    </View>
                </View>
                {votingEnabled ? (
                    <View style={{ marginLeft: 16 }}>
                        <OptionRadioButton
                            testID={optionText}
                            selected={selected}
                            onPress={onSelect}
                        />
                    </View>
                ) : null}
            </HorizBox>
        </PadBox>
    );
}

const videoVotingOptionStyle = StyleSheet.create({
    percentageBarBase: {
        height: 7,
        borderRadius: 5.5,
        overflow: "hidden"
    },
    tag: {
        display: "flex",
        borderRadius: 100,
        borderWidth: 2,
        borderColor: colorSurfaceSecondary,
        backgroundColor: "#C3C3C3",
        paddingHorizontal: 6,
        height: 24,
        justifyContent: "center",
        alignItems: "center",
    }
})